module.exports = __webpack_public_path__ + "static/media/QRcodeBertoni-playStore.0cfe6b35.svg";